import { render, staticRenderFns } from "./AssetSelectCom.vue?vue&type=template&id=586258e6&"
import script from "./AssetSelectCom.vue?vue&type=script&lang=ts&"
export * from "./AssetSelectCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports